// @core/api/endpoints/bootstrap/retry_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RetryExecutionRequest,
  RetryExecutionResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Retry failed bootstrap
 * Retries a failed bootstrap execution. Resumes from the failed step — completed steps are skipped (idempotent).
 * @public This endpoint does not require authentication
 */
export async function RetryExecution(
  data: RetryExecutionRequest,
  options?: RequestOptions
): Promise<RetryExecutionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/retry`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<RetryExecutionResponse>(requestPath, data, requestOptions);
}
